import * as i1 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { forwardRef, booleanAttribute, Component, Inject, Input, ContentChildren, EventEmitter, PLATFORM_ID, numberAttribute, ChangeDetectionStrategy, ViewEncapsulation, Output, ViewChild, NgModule } from '@angular/core';
import { PrimeTemplate, SharedModule } from 'primeng/api';
import { DomHandler } from 'primeng/dom';
import { ChevronLeftIcon } from 'primeng/icons/chevronleft';
import { ChevronRightIcon } from 'primeng/icons/chevronright';
import { TimesIcon } from 'primeng/icons/times';
import * as i3 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import * as i2 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import { UniqueComponentId } from 'primeng/utils';

/**
 * TabPanel is a helper component for TabView component.
 * @group Components
 */
const _c0 = ["*"];
function TabPanel_div_0_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TabPanel_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabPanel_div_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate);
  }
}
function TabPanel_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵtemplate(2, TabPanel_div_0_ng_container_2_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r0.selected);
    i0.ɵɵattribute("id", ctx_r0.tabView.getTabContentId(ctx_r0.id))("aria-hidden", !ctx_r0.selected)("aria-labelledby", ctx_r0.tabView.getTabHeaderActionId(ctx_r0.id))("data-pc-name", "tabpanel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.contentTemplate && (ctx_r0.cache ? ctx_r0.loaded : ctx_r0.selected));
  }
}
const _c1 = ["content"];
const _c2 = ["navbar"];
const _c3 = ["prevBtn"];
const _c4 = ["nextBtn"];
const _c5 = ["inkbar"];
const _c6 = ["elementToObserve"];
const _c7 = a0 => ({
  "p-tabview p-component": true,
  "p-tabview-scrollable": a0
});
const _c8 = (a0, a1) => ({
  "p-highlight": a0,
  "p-disabled": a1
});
function TabView_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15, 4);
    i0.ɵɵlistener("click", function TabView_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navBackward());
    });
    i0.ɵɵelement(2, "span", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabindex", ctx_r2.tabindex)("aria-label", ctx_r2.scrollableLeftLabel)("title", ctx_r2.scrollableLeftLabel);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", tab_r5.leftIcon);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_1_Template, 1, 0, null, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.leftIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", tab_r5.rightIcon);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_1_ng_template_0_Template(rf, ctx) {}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_1_Template, 1, 0, null, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.rightIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_1_ng_container_2_span_1_Template, 1, 1, "span", 23)(2, TabView_ng_template_8_li_0_span_1_ng_container_2_span_2_Template, 2, 1, "span", 24);
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TabView_ng_template_8_li_0_span_1_ng_container_2_span_5_Template, 1, 1, "span", 26)(6, TabView_ng_template_8_li_0_span_1_ng_container_2_span_6_Template, 2, 1, "span", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.leftIcon && !tab_r5.leftIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.leftIconTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r5.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.rightIcon && !tab_r5.rightIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.rightIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TabView_ng_template_8_li_0_span_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵlistener("click", function TabView_ng_template_8_li_0_span_1_span_4_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const tab_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close($event, tab_r5));
    })("keydown.enter", function TabView_ng_template_8_li_0_span_1_span_4_Template_span_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const tab_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close($event, tab_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", ctx_r2.buttonTitle)("title", ctx_r2.buttonTitle);
  }
}
function TabView_ng_template_8_li_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "a", 20);
    i0.ɵɵlistener("click", function TabView_ng_template_8_li_0_span_1_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const tab_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open($event, tab_r5));
    })("keydown", function TabView_ng_template_8_li_0_span_1_Template_a_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const tab_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onTabKeyDown($event, tab_r5));
    });
    i0.ɵɵtemplate(2, TabView_ng_template_8_li_0_span_1_ng_container_2_Template, 7, 5, "ng-container", 19)(3, TabView_ng_template_8_li_0_span_1_ng_container_3_Template, 1, 0, "ng-container", 21)(4, TabView_ng_template_8_li_0_span_1_span_4_Template, 1, 2, "span", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const tab_r5 = ctx_r6.$implicit;
    const i_r8 = ctx_r6.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("pTooltip", tab_r5.tooltip)("tooltipPosition", tab_r5.tooltipPosition)("positionStyle", tab_r5.tooltipPositionStyle)("tooltipStyleClass", tab_r5.tooltipStyleClass);
    i0.ɵɵattribute("id", ctx_r2.getTabHeaderActionId(tab_r5.id))("aria-controls", ctx_r2.getTabContentId(tab_r5.id))("aria-selected", tab_r5.selected)("tabindex", tab_r5.disabled || !tab_r5.selected ? "-1" : ctx_r2.tabindex)("data-pc-index", i_r8)("data-pc-section", "headeraction")("tabindex", tab_r5.disabled ? null : "0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r5.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.closable);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", tab_r5.leftIcon);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_1_Template, 1, 0, null, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.leftIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", tab_r5.rightIcon);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_1_ng_template_0_Template(rf, ctx) {}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_1_Template, 1, 0, null, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.rightIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_2_ng_container_2_span_1_Template, 1, 1, "span", 23)(2, TabView_ng_template_8_li_0_span_2_ng_container_2_span_2_Template, 2, 1, "span", 24);
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TabView_ng_template_8_li_0_span_2_ng_container_2_span_5_Template, 1, 1, "span", 26)(6, TabView_ng_template_8_li_0_span_2_ng_container_2_span_6_Template, 2, 1, "span", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.leftIcon && !tab_r5.leftIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.leftIconTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r5.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.rightIcon && !tab_r5.rightIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.rightIconTemplate);
  }
}
function TabView_ng_template_8_li_0_span_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TabView_ng_template_8_li_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "a", 33);
    i0.ɵɵlistener("click", function TabView_ng_template_8_li_0_span_2_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const tab_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open($event, tab_r5));
    })("keydown.space", function TabView_ng_template_8_li_0_span_2_Template_a_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const tab_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open($event, tab_r5));
    })("keydown.enter", function TabView_ng_template_8_li_0_span_2_Template_a_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const tab_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open($event, tab_r5));
    });
    i0.ɵɵtemplate(2, TabView_ng_template_8_li_0_span_2_ng_container_2_Template, 7, 5, "ng-container", 19)(3, TabView_ng_template_8_li_0_span_2_ng_container_3_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("pTooltip", tab_r5.tooltip)("tooltipPosition", tab_r5.tooltipPosition)("positionStyle", tab_r5.tooltipPositionStyle)("tooltipStyleClass", tab_r5.tooltipStyleClass);
    i0.ɵɵattribute("id", ctx_r2.getTabHeaderActionId(tab_r5.id))("aria-selected", tab_r5.selected)("aria-controls", tab_r5.id)("aria-selected", tab_r5.selected)("tabindex", tab_r5.disabled ? null : "0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r5.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r5.headerTemplate);
  }
}
function TabView_ng_template_8_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 18);
    i0.ɵɵtemplate(1, TabView_ng_template_8_li_0_span_1_Template, 5, 14, "span", 19)(2, TabView_ng_template_8_li_0_span_2_Template, 4, 11, "span", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(tab_r5.headerStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c8, tab_r5.selected, tab_r5.disabled))("ngStyle", tab_r5.headerStyle);
    i0.ɵɵattribute("data-p-disabled", tab_r5.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r5.closable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r5.closable);
  }
}
function TabView_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabView_ng_template_8_li_0_Template, 3, 10, "li", 17);
  }
  if (rf & 2) {
    const tab_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", !tab_r5.closed);
  }
}
function TabView_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34, 5);
    i0.ɵɵlistener("click", function TabView_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navForward());
    });
    i0.ɵɵelement(2, "span", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabindex", ctx_r2.tabindex)("aria-label", ctx_r2.scrollableRightLabel)("title", ctx_r2.scrollableRightLabel);
  }
}
let TabPanel = /*#__PURE__*/(() => {
  class TabPanel {
    el;
    viewContainer;
    cd;
    /**
     * Defines if tab can be removed.
     * @group Props
     */
    closable = false;
    /**
     * Inline style of the tab header.
     * @group Props
     */
    get headerStyle() {
      return this._headerStyle;
    }
    set headerStyle(headerStyle) {
      this._headerStyle = headerStyle;
      this.tabView.cd.markForCheck();
    }
    /**
     * Style class of the tab header.
     * @group Props
     */
    get headerStyleClass() {
      return this._headerStyleClass;
    }
    set headerStyleClass(headerStyleClass) {
      this._headerStyleClass = headerStyleClass;
      this.tabView.cd.markForCheck();
    }
    /**
     * Whether a lazy loaded panel should avoid getting loaded again on reselection.
     * @group Props
     */
    cache = true;
    /**
     * Advisory information to display in a tooltip on hover.
     * @group Props
     */
    tooltip;
    /**
     * Position of the tooltip.
     * @group Props
     */
    tooltipPosition = 'top';
    /**
     * Type of CSS position.
     * @group Props
     */
    tooltipPositionStyle = 'absolute';
    /**
     * Style class of the tooltip.
     * @group Props
     */
    tooltipStyleClass;
    /**
     * Defines if tab is active.
     * @defaultValue false
     * @group Props
     */
    get selected() {
      return !!this._selected;
    }
    set selected(val) {
      this._selected = val;
      if (!this.loaded) {
        this.cd.detectChanges();
      }
      if (val) this.loaded = true;
    }
    /**
     * When true, tab cannot be activated.
     * @defaultValue false
     * @group Props
     */
    get disabled() {
      return !!this._disabled;
    }
    set disabled(disabled) {
      this._disabled = disabled;
      this.tabView.cd.markForCheck();
    }
    /**
     * Title of the tabPanel.
     * @group Props
     */
    get header() {
      return this._header;
    }
    set header(header) {
      this._header = header;
      // We have to wait for the rendering and then retrieve the actual size element from the DOM.
      // in future `Promise.resolve` can be changed to `queueMicrotask` (if ie11 support will be dropped)
      Promise.resolve().then(() => {
        this.tabView.updateInkBar();
        this.tabView.cd.markForCheck();
      });
    }
    /**
     * Left icon of the tabPanel.
     * @group Props
     * @deprecated since v15.4.2, use `lefticon` template instead.
     */
    get leftIcon() {
      return this._leftIcon;
    }
    set leftIcon(leftIcon) {
      this._leftIcon = leftIcon;
      this.tabView.cd.markForCheck();
    }
    /**
     * Left icon of the tabPanel.
     * @group Props
     * @deprecated since v15.4.2, use `righticon` template instead.
     */
    get rightIcon() {
      return this._rightIcon;
    }
    set rightIcon(rightIcon) {
      this._rightIcon = rightIcon;
      this.tabView.cd.markForCheck();
    }
    templates;
    closed = false;
    view = null;
    _headerStyle;
    _headerStyleClass;
    _selected;
    _disabled;
    _header;
    _leftIcon;
    _rightIcon = undefined;
    loaded = false;
    id;
    contentTemplate;
    headerTemplate;
    leftIconTemplate;
    rightIconTemplate;
    closeIconTemplate;
    tabView;
    constructor(tabView, el, viewContainer, cd) {
      this.el = el;
      this.viewContainer = viewContainer;
      this.cd = cd;
      this.tabView = tabView;
      this.id = UniqueComponentId();
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'content':
            this.contentTemplate = item.template;
            break;
          case 'righticon':
            this.rightIconTemplate = item.template;
            break;
          case 'lefticon':
            this.leftIconTemplate = item.template;
            break;
          case 'closeicon':
            this.closeIconTemplate = item.template;
            break;
          default:
            this.contentTemplate = item.template;
            break;
        }
      });
    }
    ngOnDestroy() {
      this.view = null;
    }
    static ɵfac = function TabPanel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabPanel)(i0.ɵɵdirectiveInject(forwardRef(() => TabView)), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabPanel,
      selectors: [["p-tabPanel"]],
      contentQueries: function TabPanel_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        closable: [2, "closable", "closable", booleanAttribute],
        headerStyle: "headerStyle",
        headerStyleClass: "headerStyleClass",
        cache: [2, "cache", "cache", booleanAttribute],
        tooltip: "tooltip",
        tooltipPosition: "tooltipPosition",
        tooltipPositionStyle: "tooltipPositionStyle",
        tooltipStyleClass: "tooltipStyleClass",
        selected: "selected",
        disabled: "disabled",
        header: "header",
        leftIcon: "leftIcon",
        rightIcon: "rightIcon"
      },
      standalone: false,
      features: [i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 1,
      consts: [["class", "p-tabview-panel", "role", "tabpanel", 3, "hidden", 4, "ngIf"], ["role", "tabpanel", 1, "p-tabview-panel", 3, "hidden"], [4, "ngIf"], [4, "ngTemplateOutlet"]],
      template: function TabPanel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, TabPanel_div_0_Template, 3, 6, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.closed);
        }
      },
      dependencies: [i1.NgIf, i1.NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return TabPanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// HIS-PATCH #266927: Schließen-Button einer Registerkarte tabbar gemacht und schließen-Text für die Grafik hinzugefügt
/**
 * TabView is a container component to group content with tabs.
 * @group Components
 */
let TabView = /*#__PURE__*/(() => {
  class TabView {
    platformId;
    el;
    cd;
    renderer;
    buttonTitle;
    scrollableRightLabel;
    scrollableLeftLabel;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Whether tab close is controlled at onClose event or not.
     * @defaultValue false
     * @group Props
     */
    controlClose;
    /**
     * When enabled displays buttons at each side of the tab headers to scroll the tab list.
     * @defaultValue false
     * @group Props
     */
    scrollable = true;
    /**
     * Index of the active tab to change selected tab programmatically.
     * @group Props
     */
    get activeIndex() {
      return this._activeIndex;
    }
    set activeIndex(val) {
      this._activeIndex = val;
      if (this.preventActiveIndexPropagation) {
        this.preventActiveIndexPropagation = false;
        return;
      }
      if (this.tabs && this.tabs.length && this._activeIndex != null && this.tabs.length > this._activeIndex) {
        this.findSelectedTab().selected = false;
        this.tabs[this._activeIndex].selected = true;
        this.tabChanged = true;
        this.updateScrollBar(val);
      }
    }
    /**
     * When enabled, the focused tab is activated.
     * @group Props
     */
    selectOnFocus = false;
    /**
     * Used to define a string aria label attribute the forward navigation button.
     * @group Props
     */
    nextButtonAriaLabel;
    /**
     * Used to define a string aria label attribute the backward navigation button.
     * @group Props
     */
    prevButtonAriaLabel;
    /**
     * When activated, navigation buttons will automatically hide or show based on the available space within the container.
     * @group Props
     */
    autoHideButtons = true;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex = 0;
    /**
     * Callback to invoke on tab change.
     * @param {TabViewChangeEvent} event - Custom tab change event
     * @group Emits
     */
    onChange = new EventEmitter();
    /**
     * Callback to invoke on tab close.
     * @param {TabViewCloseEvent} event - Custom tab close event
     * @group Emits
     */
    onClose = new EventEmitter();
    /**
     * Callback to invoke on the active tab change.
     * @param {number} index - New active index
     * @group Emits
     */
    activeIndexChange = new EventEmitter();
    content;
    navbar;
    prevBtn;
    nextBtn;
    inkbar;
    tabPanels;
    templates;
    initialized;
    tabs;
    _activeIndex;
    preventActiveIndexPropagation;
    tabChanged;
    backwardIsDisabled = true;
    forwardIsDisabled = false;
    tabChangesSubscription;
    nextIconTemplate;
    previousIconTemplate;
    resizeObserver;
    container;
    list;
    buttonVisible;
    elementToObserve;
    constructor(platformId, el, cd, renderer) {
      this.platformId = platformId;
      this.el = el;
      this.cd = cd;
      this.renderer = renderer;
    }
    ngAfterContentInit() {
      this.initTabs();
      this.tabChangesSubscription = this.tabPanels.changes.subscribe(_ => {
        this.initTabs();
        this.refreshButtonState();
        this.callResizeObserver();
      });
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'previousicon':
            this.previousIconTemplate = item.template;
            break;
          case 'nexticon':
            this.nextIconTemplate = item.template;
            break;
        }
      });
    }
    callResizeObserver() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.autoHideButtons) {
          this.bindResizeObserver();
        }
      }
    }
    ngAfterViewInit() {
      this.callResizeObserver();
    }
    bindResizeObserver() {
      this.container = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="navcontent"]');
      this.list = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="nav"]');
      this.resizeObserver = new ResizeObserver(() => {
        if (this.list.offsetWidth >= this.container.offsetWidth) {
          this.buttonVisible = true;
        } else {
          this.buttonVisible = false;
        }
        this.updateButtonState();
        this.cd.detectChanges();
      });
      this.resizeObserver.observe(this.container);
    }
    unbindResizeObserver() {
      this.resizeObserver.unobserve(this.elementToObserve.nativeElement);
      this.resizeObserver = null;
    }
    ngAfterViewChecked() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.tabChanged) {
          this.updateInkBar();
          this.tabChanged = false;
        }
      }
    }
    ngOnDestroy() {
      if (this.tabChangesSubscription) {
        this.tabChangesSubscription.unsubscribe();
      }
      if (this.resizeObserver) {
        this.unbindResizeObserver();
      }
    }
    getTabHeaderActionId(tabId) {
      return `${tabId}_header_action`;
    }
    getTabContentId(tabId) {
      return `${tabId}_content`;
    }
    initTabs() {
      this.tabs = this.tabPanels.toArray();
      let selectedTab = this.findSelectedTab();
      if (!selectedTab && this.tabs.length) {
        if (this.activeIndex != null && this.tabs.length > this.activeIndex) this.tabs[this.activeIndex].selected = true;else this.tabs[0].selected = true;
        this.tabChanged = true;
      }
      this.cd.markForCheck();
    }
    onTabKeyDown(event, tab) {
      switch (event.code) {
        case 'ArrowLeft':
          this.onTabArrowLeftKey(event);
          break;
        case 'ArrowRight':
          this.onTabArrowRightKey(event);
          break;
        case 'Home':
          this.onTabHomeKey(event);
          break;
        case 'End':
          this.onTabEndKey(event);
          break;
        case 'PageDown':
          this.onTabEndKey(event);
          break;
        case 'PageUp':
          this.onTabHomeKey(event);
          break;
        case 'Enter':
        case 'Space':
          this.open(event, tab);
          break;
        default:
          break;
      }
    }
    onTabArrowLeftKey(event) {
      const prevHeaderAction = this.findPrevHeaderAction(event.target.parentElement);
      const index = DomHandler.getAttribute(prevHeaderAction, 'data-pc-index');
      prevHeaderAction ? this.changeFocusedTab(event, prevHeaderAction, index) : this.onTabEndKey(event);
      event.preventDefault();
    }
    onTabArrowRightKey(event) {
      const nextHeaderAction = this.findNextHeaderAction(event.target.parentElement);
      const index = DomHandler.getAttribute(nextHeaderAction, 'data-pc-index');
      nextHeaderAction ? this.changeFocusedTab(event, nextHeaderAction, index) : this.onTabHomeKey(event);
      event.preventDefault();
    }
    onTabHomeKey(event) {
      const firstHeaderAction = this.findFirstHeaderAction();
      const index = DomHandler.getAttribute(firstHeaderAction, 'data-pc-index');
      this.changeFocusedTab(event, firstHeaderAction, index);
      event.preventDefault();
    }
    onTabEndKey(event) {
      const lastHeaderAction = this.findLastHeaderAction();
      const index = DomHandler.getAttribute(lastHeaderAction, 'data-pc-index');
      this.changeFocusedTab(event, lastHeaderAction, index);
      event.preventDefault();
    }
    changeFocusedTab(event, element, index) {
      if (element) {
        DomHandler.focus(element);
        element.scrollIntoView({
          block: 'nearest'
        });
        if (this.selectOnFocus) {
          const tab = this.tabs[index];
          this.open(event, tab);
        }
      }
    }
    findNextHeaderAction(tabElement, selfCheck = false) {
      const headerElement = selfCheck ? tabElement : tabElement.nextElementSibling;
      return headerElement ? DomHandler.getAttribute(headerElement, 'data-p-disabled') || DomHandler.getAttribute(headerElement, 'data-pc-section') === 'inkbar' ? this.findNextHeaderAction(headerElement) : DomHandler.findSingle(headerElement, '[data-pc-section="headeraction"]') : null;
    }
    findPrevHeaderAction(tabElement, selfCheck = false) {
      const headerElement = selfCheck ? tabElement : tabElement.previousElementSibling;
      return headerElement ? DomHandler.getAttribute(headerElement, 'data-p-disabled') || DomHandler.getAttribute(headerElement, 'data-pc-section') === 'inkbar' ? this.findPrevHeaderAction(headerElement) : DomHandler.findSingle(headerElement, '[data-pc-section="headeraction"]') : null;
    }
    findFirstHeaderAction() {
      const firstEl = this.navbar.nativeElement.firstElementChild;
      return this.findNextHeaderAction(firstEl, true);
    }
    findLastHeaderAction() {
      const lastEl = this.navbar.nativeElement.lastElementChild;
      const lastHeaderAction = DomHandler.getAttribute(lastEl, 'data-pc-section') === 'inkbar' ? lastEl.previousElementSibling : lastEl;
      return this.findPrevHeaderAction(lastHeaderAction, true);
    }
    open(event, tab) {
      if (tab.disabled) {
        if (event) {
          event.preventDefault();
        }
        return;
      }
      if (!tab.selected) {
        let selectedTab = this.findSelectedTab();
        if (selectedTab) {
          selectedTab.selected = false;
        }
        this.tabChanged = true;
        tab.selected = true;
        let selectedTabIndex = this.findTabIndex(tab);
        this.preventActiveIndexPropagation = true;
        this.activeIndexChange.emit(selectedTabIndex);
        this.onChange.emit({
          originalEvent: event,
          index: selectedTabIndex
        });
        this.updateScrollBar(selectedTabIndex);
      }
      if (event) {
        event.preventDefault();
      }
    }
    close(event, tab) {
      if (this.controlClose) {
        this.onClose.emit({
          originalEvent: event,
          index: this.findTabIndex(tab),
          close: () => {
            this.closeTab(tab);
          }
        });
      } else {
        this.closeTab(tab);
        this.onClose.emit({
          originalEvent: event,
          index: this.findTabIndex(tab)
        });
      }
    }
    closeTab(tab) {
      if (tab.disabled) {
        return;
      }
      if (tab.selected) {
        this.tabChanged = true;
        tab.selected = false;
        for (let i = 0; i < this.tabs.length; i++) {
          let tabPanel = this.tabs[i];
          if (!tabPanel.closed && !tab.disabled) {
            tabPanel.selected = true;
            break;
          }
        }
      }
      tab.closed = true;
      setTimeout(() => {
        this.updateInkBar();
      });
    }
    findSelectedTab() {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].selected) {
          return this.tabs[i];
        }
      }
      return null;
    }
    findTabIndex(tab) {
      let index = -1;
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i] == tab) {
          index = i;
          break;
        }
      }
      return index;
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    updateInkBar() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.navbar) {
          const tabHeader = DomHandler.findSingle(this.navbar.nativeElement, 'li.p-highlight');
          if (!tabHeader) {
            return;
          }
          this.inkbar.nativeElement.style.width = DomHandler.getWidth(tabHeader) + 'px';
          this.inkbar.nativeElement.style.left = DomHandler.getOffset(tabHeader).left - DomHandler.getOffset(this.navbar.nativeElement).left + 'px';
        }
      }
    }
    updateScrollBar(index) {
      let tabHeader = this.navbar.nativeElement.children[index];
      if (tabHeader) {
        tabHeader.scrollIntoView({
          block: 'nearest'
        });
      }
    }
    updateButtonState() {
      const content = this.content.nativeElement;
      const {
        scrollLeft,
        scrollWidth
      } = content;
      const width = DomHandler.getWidth(content);
      this.backwardIsDisabled = scrollLeft === 0;
      this.forwardIsDisabled = Math.round(scrollLeft) === scrollWidth - width;
    }
    refreshButtonState() {
      this.container = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="navcontent"]');
      this.list = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="nav"]');
      if (this.list.offsetWidth >= this.container.offsetWidth) {
        if (this.list.offsetWidth >= this.container.offsetWidth) {
          this.buttonVisible = true;
        } else {
          this.buttonVisible = false;
        }
        this.updateButtonState();
        this.cd.markForCheck();
      }
    }
    onScroll(event) {
      this.scrollable && this.updateButtonState();
      event.preventDefault();
    }
    getVisibleButtonWidths() {
      return [this.prevBtn?.nativeElement, this.nextBtn?.nativeElement].reduce((acc, el) => el ? acc + DomHandler.getWidth(el) : acc, 0);
    }
    navBackward() {
      const content = this.content.nativeElement;
      const width = DomHandler.getWidth(content) - this.getVisibleButtonWidths();
      const pos = content.scrollLeft - width;
      content.scrollLeft = pos <= 0 ? 0 : pos;
    }
    navForward() {
      const content = this.content.nativeElement;
      const width = DomHandler.getWidth(content) - this.getVisibleButtonWidths();
      const pos = content.scrollLeft + width;
      const lastPos = content.scrollWidth - width;
      content.scrollLeft = pos >= lastPos ? lastPos : pos;
    }
    static ɵfac = function TabView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabView)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabView,
      selectors: [["p-tabView"]],
      contentQueries: function TabView_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TabPanel, 4);
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabPanels = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function TabView_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.navbar = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevBtn = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextBtn = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inkbar = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.elementToObserve = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        buttonTitle: "buttonTitle",
        scrollableRightLabel: "scrollableRightLabel",
        scrollableLeftLabel: "scrollableLeftLabel",
        style: "style",
        styleClass: "styleClass",
        controlClose: [2, "controlClose", "controlClose", booleanAttribute],
        scrollable: [2, "scrollable", "scrollable", booleanAttribute],
        activeIndex: "activeIndex",
        selectOnFocus: [2, "selectOnFocus", "selectOnFocus", booleanAttribute],
        nextButtonAriaLabel: "nextButtonAriaLabel",
        prevButtonAriaLabel: "prevButtonAriaLabel",
        autoHideButtons: [2, "autoHideButtons", "autoHideButtons", booleanAttribute],
        tabindex: [2, "tabindex", "tabindex", numberAttribute]
      },
      outputs: {
        onChange: "onChange",
        onClose: "onClose",
        activeIndexChange: "activeIndexChange"
      },
      standalone: false,
      features: [i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c0,
      decls: 14,
      vars: 13,
      consts: [["elementToObserve", ""], ["content", ""], ["navbar", ""], ["inkbar", ""], ["prevBtn", ""], ["nextBtn", ""], [3, "ngClass", "ngStyle"], [1, "p-tabview-nav-container"], ["class", "p-tabview-nav-prev p-tabview-nav-btn p-link", "type", "button", "pRipple", "", 3, "click", 4, "ngIf"], [1, "p-tabview-nav-content", 3, "scroll"], ["role", "tablist", 1, "p-tabview-nav"], ["ngFor", "", 3, "ngForOf"], ["role", "presentation", "aria-hidden", "true", 1, "p-tabview-ink-bar"], ["class", "p-tabview-nav-next p-tabview-nav-btn p-link", "type", "button", "pRipple", "", 3, "click", 4, "ngIf"], [1, "p-tabview-panels"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-prev", "p-tabview-nav-btn", "p-link", 3, "click"], [1, "pi", "pi-chevron-left"], ["role", "presentation", 3, "ngClass", "ngStyle", "class", 4, "ngIf"], ["role", "presentation", 3, "ngClass", "ngStyle"], [4, "ngIf"], ["role", "tab", "pRipple", "", 1, "p-tabview-nav-link", 3, "click", "keydown", "pTooltip", "tooltipPosition", "positionStyle", "tooltipStyleClass"], [4, "ngTemplateOutlet"], ["role", "button", "class", "p-tabview-close pi pi-times", "tabindex", "0", 3, "click", "keydown.enter", 4, "ngIf"], ["class", "p-tabview-left-icon", 3, "ngClass", 4, "ngIf"], ["class", "p-tabview-left-icon", 4, "ngIf"], [1, "p-tabview-title"], ["class", "p-tabview-right-icon", 3, "ngClass", 4, "ngIf"], ["class", "p-tabview-right-icon", 4, "ngIf"], [1, "p-tabview-left-icon", 3, "ngClass"], [1, "p-tabview-left-icon"], [1, "p-tabview-right-icon", 3, "ngClass"], [1, "p-tabview-right-icon"], ["role", "button", "tabindex", "0", 1, "p-tabview-close", "pi", "pi-times", 3, "click", "keydown.enter"], ["role", "tab", "pRipple", "", 1, "p-tabview-nav-link", 3, "click", "keydown.space", "keydown.enter", "pTooltip", "tooltipPosition", "positionStyle", "tooltipStyleClass"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-next", "p-tabview-nav-btn", "p-link", 3, "click"], [1, "pi", "pi-chevron-right"]],
      template: function TabView_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 6)(1, "div", 7, 0);
          i0.ɵɵtemplate(3, TabView_button_3_Template, 3, 3, "button", 8);
          i0.ɵɵelementStart(4, "div", 9, 1);
          i0.ɵɵlistener("scroll", function TabView_Template_div_scroll_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onScroll($event));
          });
          i0.ɵɵelementStart(6, "ul", 10, 2);
          i0.ɵɵtemplate(8, TabView_ng_template_8_Template, 1, 1, "ng-template", 11);
          i0.ɵɵelement(9, "li", 12, 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(11, TabView_button_11_Template, 3, 3, "button", 13);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "div", 14);
          i0.ɵɵprojection(13);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7, ctx.scrollable))("ngStyle", ctx.style);
          i0.ɵɵattribute("data-pc-name", "tabview");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.scrollable && !ctx.backwardIsDisabled && ctx.autoHideButtons);
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "navcontent");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("data-pc-section", "nav");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.tabs);
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "inkbar");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.scrollable && !ctx.forwardIsDisabled && ctx.buttonVisible);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.Tooltip, i3.Ripple],
      styles: [".p-tabview-nav-container{position:relative}.p-tabview-scrollable .p-tabview-nav-container{overflow:hidden}.p-tabview-nav-content{overflow-x:auto;overflow-y:hidden;scroll-behavior:smooth;scrollbar-width:none;overscroll-behavior:contain auto}.p-tabview-nav{display:inline-flex;min-width:100%;margin:0;padding:0;list-style-type:none;flex:1 1 auto}.p-tabview-nav-link{cursor:pointer;user-select:none;display:flex;align-items:center;position:relative;text-decoration:none;overflow:hidden}.p-tabview-ink-bar{display:none;z-index:1}.p-tabview-nav-link:focus{z-index:1}.p-tabview-title{line-height:1;white-space:nowrap}.p-tabview-nav-btn{position:absolute;top:0;z-index:2;height:100%;display:flex;align-items:center;justify-content:center}.p-tabview-nav-prev{left:0}.p-tabview-nav-next{right:0}.p-tabview-nav-content::-webkit-scrollbar{display:none}.p-tabview-close{z-index:1}p-tabview>div.p-tabview>div>div.p-tabview-nav-content>ul>li>span>a.p-tabview-nav-link.closable{padding-right:2.5em}p-tabview>div.p-tabview>div>div.p-tabview-nav-content>ul>li>span>span.p-tabview-close{position:relative;margin-top:-1.7em;margin-right:.5em;float:right;cursor:pointer}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return TabView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TabViewModule = /*#__PURE__*/(() => {
  class TabViewModule {
    static ɵfac = function TabViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabViewModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabViewModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule, TooltipModule, RippleModule, TimesIcon, ChevronLeftIcon, ChevronRightIcon, SharedModule]
    });
  }
  return TabViewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TabPanel, TabView, TabViewModule };
